<template>
	<div class="row">

		<!-- FORM -->
		<div class="col-12" >
			<div class="row">
				<div class="col-12">
					<div class="account__block__title">{{ t('user.page.payin.title') }}</div>
				</div>
			</div>
			<form @submit.prevent="validateForm('payin')" data-vv-scope="payin" class="block block--visible" v-if="!iFrame">
				<div class="block__content account__block__content__payin">

					<div class="row">
						<div class="col-12">
							{{t('user.page.payin.type.label')}}
						</div>
					</div>
					<div class="row col-12">
						<form-message :messages="getMessage( 'payin1')"></form-message>
					</div>
					<div class="row">
						<div class="col-6 col-sm-4 col-md-3" v-if="ptype.active" :key="'payin-type-key--'+ptype.name" v-for="ptype in paymentTypes">
							<div class="row">
								<div class="col-6 d-flex justify-content-end align-items-center">
									<input v-model="payinType" :data-vv-as="t('user.page.payin.field-name')" type="radio" :id="ptype.method" name="ptype" :value="ptype.method" class="checkbox" v-validate="'required'">
									<label :for="ptype.method"></label>
								</div>
								<label :for="ptype.method" class="col-6 pt-5 pb-5 mb-0">
									<img :src="encodeURI(ptype.image)" :alt="ptype.name">
									<!--{{ptype.name}}-->
								</label>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<div v-if="isInValid('payin.ptype')"
								 class="invalid-feedback"
								 :class="{ 'd-block': isInValid('payin.ptype')}">
								{{ errors.first('payin.ptype') }}
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-lg-4 align-items-center d-flex">
							{{t('user.page.payin.amount.label')}}
						</div>
						<div class="col-9 col-lg-3 form-group mb-0">
							<input
									v-model="payinAmount"
									v-validate="amountRules"
									:data-vv-as="t('user.page.payin.field-name.amount')"
									type="text"
									class="form-control"
									:class="validClasses('payin.payinAmount')"
									name="payinAmount"
									placeholder="">
							<div v-if="isInValid('payin.payinAmount')"
								 class="invalid-feedback">
								{{ errors.first('payin.payinAmount') }}
							</div>
						</div>
						<div class="col-1 col-lg-1 align-items-center d-flex">
							€.
						</div>
					</div>

					<div class="row justify-content-center pt-4 pb-3 mt-5">
						<div class="col-12 col-lg-3">
							<button class="btn btn-primary" type="submit">
								<loader v-if="isLoading" :size="20" :color="'#303539'"></loader>
								{{t('user.page.payin.btn')}}
							</button>
						</div>
					</div>
				</div>
			</form>
			<div class="row" v-if="iFrame">
				<div class="col-12">
					<iframe class="account__payin-iframe" :src="iFrame" width="100%"></iframe>
				</div>
			</div>

		</div>

	</div>
</template>
<script>
	import Vuex from 'vuex';
	import store from '@/store';
	import {instance, userApi} from "@/api";
	import FormMessage from '@/components/parts/form-message';


	export default {
		name: 'UserPayin',
		components:{
			FormMessage
		},
		beforeRouteEnter(to, from, next){
			store.dispatch('getUserPayinOptions').then(()=>{
				next();

			}).catch(function () {
				next();

			})
		},
		beforeRouteLeave (to, from, next){
			this.iFrame = null;
			next();
		},
		data() {
			return {
				name: 'payin1',
				formMsg: [],

				iFrame: null,
				payinType: '',
				payinAmount: '',
			}
		},
		computed:{
			...Vuex.mapGetters({
				paymentTypes: 'getPaymentTypes'
			}),
			isLoading(){
				return this.$store.state.loaderList.some( el => el === this.name);
			},
			activeType(){

				if(!this.payinType){
					return null;
				}

				return this.paymentTypes.find((el)=> el.method === this.payinType );
			},
			amountRules(){

				let rule  = {
					required: true,
					decimal: [2, '&?[,.]'],
					/*min_value: 1,
					max_value: 2*/
				};

				/*
				* comment:"Deposit via VISA"
				created:"2018-10-29 08:20:10"
				id:1
				image:"visa.png"
				max_deposit:200000
				method:"VISA"
				min_deposit:1000
				modified:null
				name:"VISA"
				position:0
				status:1*/

				if(this.activeType){
					rule.min_value_decimal = this.activeType['min_deposit'] / 100;
					rule.max_value_decimal = this.activeType['max_deposit'] / 100;

				}

				return rule;

			},
		},
		methods:{
			validateForm(scope) {
				this.$validator.validateAll(scope).then((result) => {
					if (result) {

						this.doPayin();

					}
				});
			},
			doPayin(){

				this.addLoad(this.name);
				this.deleteMessage(this.name);

				let amount = this.payinAmount.replace(',', '.');

            amount =  parseInt(parseFloat(amount) * 100)

				instance.post(userApi.deposit, {
					amount,
					paymentmethod: this.payinType
				}).then(({data})=>{

					if(data){
						if(data.status === 'SUCCESS' && data.content.status === 1){
							if(data.content && data.content.url){
								this.iFrame = data.content.url
							}
						}else if(data.status === 'ERROR'){

							this.restMessageHandler('ERROR', this.name, data.error);
						}else{
                     this.addMessage( {
                        scope: this.name,
                        state: 'ERROR',
                        text: this.t('userpayin.message.unhandled')
                     });
                  }
					}else{
						console.warn('Call no data!');
						console.log(data);
					}

					//Expect
					/*
					    expire: "2018-11-02T16:06:42.795+01:00"
						status: 1
						url: "https://test.saferpay.com/vt2/api/PaymentPage/401860/17795278/gffdm3iq78sje8tjnb4gitmb8"
					* */


				}).catch(()=>{
					this.addMessage( {
						scope: 'payin1',
						state: 'danger',
						text: this.t('userpayin.1.fail')
					});
				}).then(()=>{
					this.endLoad(this.name);
				})

			}
		}

	}
</script>
